import { useRefCallback } from "../useRefCallback";
import useForceRender from "../useForceRender";
export function useReactiveRef(initialValue) {
  var forceRender = useForceRender();
  var ref = useRefCallback(forceRender, initialValue);
  return ref;
}